import { useMemo } from "react";
import { canUseFeature, Feature } from "@memento/library/feature-access";
import { Card } from "@memento/types/card";
import { useFeatureFlags } from "src/contexts/FeatureFlagProvider";
import { useSubscription } from "src/hooks/useSubscription";

/**
 * NOTE: This should only be used if you expect to get the subscription from
 * useSubscription. If the subscription comes from another source, call
 * canUseFeature directly.
 */
export function useCanUseFeature(
  feature: Feature,
  { card }: { card?: Card } = {}
) {
  const { subscription } = useSubscription();
  const { featureFlags } = useFeatureFlags();

  const canUse = useMemo(
    () =>
      canUseFeature(feature, subscription, {
        card,
        featureFlags,
      }),
    [feature, subscription, card, featureFlags]
  );

  return canUse;
}
